/** The order page's empty states (plan §1.6): what happened and where to go, for an
 *  order that does not exist or that the operator may not see — the records core's
 *  `RecordEmptyState`, pointing back to the orders grid. */
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import { Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

import { RecordEmptyState } from '@/features/records/page/RecordStates';

const BACK = (
  <Button component={RouterLink} to="/orders" startIcon={<ArrowBackIcon />} size="small">
    Back to orders
  </Button>
);

export function OrderNotFound({ id }: { id: number | string }) {
  return (
    <RecordEmptyState icon={<SearchOffIcon />} title={`Order #${id} not found`} action={BACK}>
      No order has this id — it may have been deleted (its bookings are kept), or the link carries an order ref
      rather than the console’s id. Search the orders grid by its reference instead.
    </RecordEmptyState>
  );
}

export function OrderNoPermission({ id }: { id: number | string }) {
  return (
    <RecordEmptyState icon={<LockOutlinedIcon />} title={`You can’t open order #${id}`} action={BACK}>
      Your console role does not include orders. Ask an Ops admin for the console_orders_view permission.
    </RecordEmptyState>
  );
}
